<template>
  <div>
    <Modal class="modal" v-model="modal" :title="$t('RecordData')" :footer-hide="true" :mask-closable="false" width="700" @on-cancel="cancel">
      <div class="modalinfo">
        <div class="fanTable" v-if="type ==1">
          <myTable ref="table" :columns="columns" :params="{wellness_id:itemObj.wellness_id}" requestUrl="wellness/fans-list" :showPage="true">
            <template v-slot:action="{ data }">
              <Icon class="cursor_p mg-left15" @click="goInfo(data.row)" type="ios-eye" size="26" color="#7D7C7F" />
            </template>
          </myTable>
        </div>
        <div class="cell" v-else>
          <myDetailCell v-if="labels.length > 0" :info="labels" :title="$t('info')"></myDetailCell>
          <Row justify="end" class="mg-top20">
            <Col>
              <Button @click="type =1">{{$t("back")}}</Button>
            </Col>
          </Row>
          <div class="mb_30"></div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import myTable from "@/components/myTable";
import myDetailCell from "@/components/myDetailCell";
export default {
  name: "fanList",
  components: { myTable, myDetailCell },
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
    itemObj: Object,
  },
  data () {
    return {
      columns: [
        {
          title: this.$t("Info.code"),
          key: "share_id",
          align: "center",
        },
        {
          title: this.$t("name"),
          key: "name",
          align: "center",
          tooltip: true,
        },
        {
          title: this.$t("add_time"),
          key: "add_time",
          tooltip: true,
          align: "center"
        },
        {
          title: this.$t("op"),
          align: "center",
          slot: "action",
        },
      ],
      type: 1,
      labels: [],
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    goInfo (row) {
      this.labels = [
        { label: 'ID', value: row.share_id },
        { label: this.$t("name"), value: row.name },
        { label: this.$t("add_time"), value:row.add_time, },
        { label: this.$t("teacher_record.phone"), value: row.tel, },
        { label: this.$t("teacher_record.email"), value: row.email, },
        { label: this.$t("cms_email.content"), value: row.remark, },
      ];
      this.type = 2;
    },
    cancel () {
      this.$emit('cancel');
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .modal {
  .mb_30 {
    margin-bottom: 30px;
  }
}
/deep/.ivu-table {
}
</style>



// WEBPACK FOOTER //
// src/pages/edu/wellness/module/fanList.vue